export interface GenericResponse {
	result: string;
}

export const GENERIC_ERROR_CODE = 1;

// Authentication service errors
export const USER_NOT_FOUND_ERROR_CODE = 4;
export const WRONG_PASSWORD_ERROR_CODE = 5;

export interface ApiError {
	code: number;
	error: string;
}

export function isApiError(value: unknown): value is ApiError {
	return (
		value instanceof Object &&
		(value as ApiError).code !== undefined &&
		(value as ApiError).error !== undefined
	);
}

export function isApiWaitingOrError(value: unknown): value is null | ApiError {
	return value === null || isApiError(value);
}
